import { inject, Injectable } from "@angular/core";
import { EnvironmentService } from "../environment.service";

declare global {
    interface Window {
        dataLayer: any[];
    }

    function gtag(...args: any[]): void;
}


@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {

    environmentService = inject(EnvironmentService);

    get token() {
        return this.environmentService.env.googleAnalyticsToken;
    }

    constructor() {
        this.injectGAScript();
      }

    private injectGAScript() {
        // Create gtag function
        window.dataLayer = window.dataLayer || [];
        window['gtag'] = function (...args: any[]) {
            window.dataLayer.push(args);
        };

        // Load gtag.js
        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${this.token}`;
        script.async = true;
        script.crossOrigin = 'anonymous';
        script.onerror = (error) => {
            console.error('Failed to load Google Analytics script:', error);
        };
        document.head.appendChild(script);

        // Configure GA
        window.gtag('js', new Date());
        window.gtag('config', this.token);
    }

    setUserProperties(sessionId: string, properties: any) {
        gtag('set', {
            user_id: sessionId,
            ...properties
        });
    }

    logPage(url: string) {
        gtag('config', this.token, {
            page_path: url
        });
    }

    logEvent(eventName: string, params: any = {}) {
        gtag('event', eventName, params);
    }
}